<div class="card-body">

  <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
  <button *ngIf="!InProccessing" (click)="Read_DeviceLetterList_Seleted()" type="button" class="btn btn-info"
    style="margin-right: 5px;"><i class="fa  fa-search"></i> Search</button>
  <button *ngIf="!InProccessing" type="button" (click)="openModal_Device(templateDevice)" class="btn btn-danger left">
    Select Instrument <i class="fa fa-cc-amex"></i> </button>

  <br>
  <br>

  <div class="table-responsive" >
    <table class="mb-0 table table-bordered table-3 text-center table-striped">
      <thead style="background-color: #489b39; color: white;">
        <tr>
          <th>#</th>
          <th>Instrument Name</th>
          <th>Count</th>
          <th>Validity Period</th>
          <th>Manager Adjustment (IRR)</th>
          <th>Unit Amount (IRR)</th>
          <th>Total (IRR)</th>
          <th>Remarks</th>
          <th>Description</th>
          <th>View Description</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of DeviceLetterList_Seleted">

          <tr>
            <td>{{DeviceLetterList_Seleted.indexOf(item)+1}}</td>
            <td>{{item.device_name}}</td>
            <td>{{item.tedad}}</td>
            <td>{{item.expiration_title}}</td>
            <td>{{item.incRailModir|number}}</td>
            <td>{{item.price|number}}</td>
            <td>{{( (item.price + item.incRailModir ) *item.tedad)|number}}</td>
            <td>{{item.price_dsc}}</td>
            <td>{{item.dscUser}}</td>
            <td>
              <p *ngIf="item.dscVisible" style="color: #489b39;">View Description </p>
              <p *ngIf="!item.dscVisible" style="color: crimson;">Hide Description </p>
            </td>
            <td>
              <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                <div class="btn-group" role="group">
                  <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Actions
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a class="dropdown-item" style="cursor: pointer;" (click)="RemoveActivityDevice(item)"><i class="fa fa-remove"></i> Delete </a>
                  <a *ngIf="!item.dscVisible" style="cursor: pointer;" class="dropdown-item" (click)="SwichActivityDevice(item)"><i class="fa fa-eye"></i> View Description </a>
                  <a *ngIf="item.dscVisible" style="cursor: pointer;" class="dropdown-item" (click)="SwichActivityDevice(item)"><i class="fa fa-eye-slash"></i> Hide Description </a>
                  </div>
                </div>
              </div>
               <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                  
              </div>
            </td>

          </tr>
          <tr style="background:#d0d2db;">
            <td style="font-weight: bolder;" colspan="4">Description Customer</td>
            <td colspan="6">
              <input class="form-control" placeholder="Type here..." type="text" [(ngModel)]="item.dscMission" />
            </td>
            <td>
              <button (click)="SubmitDeviceMissionDsc(item)" class="btn btn-info"><i class="fa fa-plus"></i>
                Register Description</button>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>


</div>




<ng-template #templateDevice>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Customer Site Instrument Information for Letter '{{inner_Letter_id}}'
    </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Device.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">

      </div>

      <div class="table-responsive" style="max-height:300px ;">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Instrument Name</th>
              <th>Count</th>
              <th>Validity Period</th>
              <th>Manager Adjustment (IRR)</th>
              <th>Unit Amount (IRR)</th>
              <th>Total (IRR)</th>
              <th>Remarks</th>
              <th>Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DeviceLetterList">
              <td>{{DeviceLetterList.indexOf(item)+1}}</td>
              <td>{{item.device_name}}</td>
              <td>{{item.tedad}}</td>
              <td>{{item.expiration_title}}</td>
              <td>{{item.incRailModir|number}}</td>
              <td>{{item.price|number}}</td>
              <td>{{( (item.price + item.incRailModir ) *item.tedad)|number}}</td>
              <td>{{item.price_dsc}}</td>
              <td>{{item.dscUser}}</td>
              <td>
                <button (click)="Add_Device(item)" class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingDevice" src="assets/Loading.gif" style="width: 25px;" />
    <button (click)="Add_DeviceAll()" *ngIf="DeviceLetterList.length>0" class="btn btn-success"><i class="fa fa-check"></i> Select All</button>
    <button *ngIf="!ProcssingDevice" type="button" (click)="Read_DeviceLetterList()" class="btn btn-info"
      style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Device.hide()">Close</button>
  </div>
</ng-template>